'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var toLongHex = function toLongHex(short) {
  if (short.length > 6) return short;

  var hex = short.split('').map(function (d) {
    if (d === '#') return d;
    return d + d;
  }).join('');

  return hex;
};

var toRgb = function toRgb(hex) {
  return [0, 0, 0].map(function (v, i) {
    var i2 = i * 2;
    return parseInt(toLongHex(hex).replace(/^#/, '').slice(i2, i2 + 2), 16);
  });
};

var isDark = function isDark(hex) {
  if (typeof hex !== 'string' || !/^#/.test(hex)) {
    return null;
  }

  var _toRgb = toRgb(hex);

  var _toRgb2 = _slicedToArray(_toRgb, 3);

  var r = _toRgb2[0];
  var g = _toRgb2[1];
  var b = _toRgb2[2];

  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq < 128;
};

exports.default = isDark;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/util/is-dark.js
// module id = t/sO
// module chunks = 1